import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Link, useNavigate } from 'react-router-dom'
import useDocumentTitle from '../hooks/useDocumentTitle'
import './UnauthorizedPage.css'

const UnauthorizedPage = ({ statusCode = 403, message = null, showHome = true, onRetry = null }) => {
  useDocumentTitle(statusCode === 401 ? 'Sign in required' : 'Access denied')
  const navigate = useNavigate()
  const primaryRef = useRef(null)

  useEffect(() => {
    primaryRef.current?.focus({ preventScroll: true })
  }, [])

  const isAuth = statusCode === 401
  const title = isAuth ? 'Sign in required' : 'Access denied'
  const subtitle =
    message ||
    (isAuth
      ? 'Your session has expired. Sign in again to keep working on this surface.'
      : "You don't have permission to view this page. Try a different account or head back to the dashboard.")

  const handleBack = () => {
    if (window.history.length > 1) navigate(-1)
    else navigate('/', { replace: true })
  }

  return (
    <main className="uz-page has-grain" role="main" aria-labelledby="uz-title">
      <div className="uz-content">
        <div className="uz-code" aria-hidden>
          {statusCode}
        </div>
        <h1 id="uz-title" className="uz-title fluid-headline">{title}</h1>
        <p className="uz-subtitle fluid-subhead">{subtitle}</p>
        <div className="uz-actions">
          {onRetry && (
            <button
              ref={primaryRef}
              type="button"
              className="uz-button uz-button--primary btn-magnetic"
              onClick={onRetry}
            >
              Try again
            </button>
          )}
          {showHome && (
            <Link
              ref={onRetry ? undefined : primaryRef}
              to="/"
              className={`uz-button ${onRetry ? 'uz-button--ghost' : 'uz-button--primary btn-magnetic'}`}
            >
              Take me home
            </Link>
          )}
          {showHome && (
            <button
              type="button"
              className="uz-button uz-button--ghost"
              onClick={handleBack}
            >
              Go back
            </button>
          )}
        </div>
      </div>
    </main>
  )
}

UnauthorizedPage.propTypes = {
  statusCode: PropTypes.oneOf([401, 403]),
  message: PropTypes.string,
  // Off when home is itself out of reach (no ShortCircuit access at all).
  showHome: PropTypes.bool,
  onRetry: PropTypes.func,
}

export default UnauthorizedPage
